











import app from "@/app";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";
import { SXCompany } from "../gobl.bundle";

@Component
export default class WCompanyPicEdit extends BaseComponent {
	@Prop({ type: SXCompany, required: true })
	company!: SXCompany;

	get options() {
		return {
			enableResize: false
		};
	}
	get outputOptions() {
		return {
			type: "blob",
			format: "jpeg"
		};
	}

	finish() {
		let rCtx = app.store.routeContext,
			next = <string>rCtx.getStateItem("next");

		if (!next) {
			app.router.goBack();
		} else {
			(window as any).location = next;
		}
	}

	onEditSuccess(data: any) {
		let x = this,
			formData = new FormData();

		formData.append(SXCompany.COL_IMAGE, data.data);

		app.services.companies.update(
			this.company.id,
			formData,
			function() {
				x.finish();
			},
			function(response) {
				app.view.dialog(response);
			},
			true
		);
	}
}
